import { RecordContextProvider, ReferenceField, TextField } from "react-admin";
import DescriptionIcon from "@mui/icons-material/Description";
import { Box, Grid, Typography } from "@mui/material";

import { employeeRequests } from "api/employeeApi";

import { templateLabel } from "../templateLabels";
import TemplateActions from "./TemplateActions";

// Dashed frame + centred primary icon, mirroring the FileInput dropzone of the leave-request forms.
const cardStyle = {
  height: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1.5,
  p: 2,
  textAlign: "center",
  borderRadius: 2,
  border: theme => `1px dashed ${theme.palette.divider}`,
};

// Labels come from the backend type lookups, so the only slug translated client-side is `key`.
const TypeCaption = ({ template }) => (
  <RecordContextProvider value={template}>
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 0.5, color: "text.secondary" }}>
      <ReferenceField
        source="type"
        reference={employeeRequests.getBusinessTripsSelect()}
        link={false}
        emptyText="—"
      >
        <TextField source="nameBg" />
      </ReferenceField>
      {template?.category != null && (
        <>
          <span>·</span>
          <ReferenceField
            source="category"
            reference={employeeRequests.getDomesticTripCategoriesSelect()}
            link={false}
          >
            <TextField source="nameBg" />
          </ReferenceField>
        </>
      )}
    </Box>
  </RecordContextProvider>
);

const TemplateCard = ({ template }) => (
  <Grid
    item
    xs={12}
    md={6}
  >
    <Box sx={cardStyle}>
      <Box>
        <Typography sx={{ fontWeight: 600 }}>{templateLabel(template?.key)}</Typography>
        <TypeCaption template={template} />
      </Box>
      <DescriptionIcon
        color="primary"
        sx={{ fontSize: 56 }}
      />
      <TemplateActions documentId={template?.documentId} />
    </Box>
  </Grid>
);

export default TemplateCard;
